import { EventDispatcher,Vector2 } from 'three';

import { Utils } from '../core/utils.js';
import { EVENT_MOVED } from '../core/events.js';

/**
 * A Arrow is the basic element.
 */
export class Arrow extends EventDispatcher {
    constructor(start, end, id) {
        super();

        this.id = id || Utils.guide();
        this.__start = new Vector2(start.x,start.y);
        this.__end = new Vector2(end.x,end.y);
        this.__name = 'Arrow';

        this.__location = new Vector2();

        this.__rotation = 0;
        this.__scale = 1;
    }

    set start(vec2){
        this.__start = vec2;
    }

    get start(){
        return this.__start;
    }
    get end(){
        return this.__end;
    }

    set end(vec2){
        this.__end = vec2;
    }

    get name(){
        return this.__name;
    }

    get rotation(){
        return this.__rotation;
    }

    get scale(){
        return this.__scale;
    }

    get location() {
        return this.__location;
    }

    set location(vec2) {
        let s = this.start.clone();
        let e = this.end.clone();
        let vect = e.clone().sub(s);
        let midPoint = s.clone().add(vect.clone().multiplyScalar(0.5));
        let vectorSToMid = s.clone().sub(midPoint);
        let vectorEToMid = e.clone().sub(midPoint);
        let sNewLocation = vec2.clone().add(vectorSToMid);
        let eNewLocation = vec2.clone().add(vectorEToMid);
        this.start = new Vector2(sNewLocation.x, sNewLocation.y);
        this.end = new Vector2(eNewLocation.x, eNewLocation.y);
        this.__location = vec2;
        this.dispatchEvent({ type: EVENT_MOVED, item: this });
    }

    arrowDirection() {
        let vector = this.end.clone().sub(this.start);
        return vector;
    }

    arrowDirectionNormalized() {
        return this.arrowDirection().normalize();
    }

    angleArrow(){
        return this.start.angleTo(this.end);
    }

    metadata(){
        let json = {};
        json.id = this.id;
        json.name = this.name;
        json.start = this.start;
        json.end = this.end;
        json.location = this.location;
        json.rotation = this.rotation;
        json.scale = this.scale;
        return json;
    }

}